import ActionButton from "../common/ActionButton";
import CategoryBadge from "../common/CategoryBadge";
import type { Event } from "../../types/event";

type Props = {
    event: Event;
};

export default function EventSpotlight({ event }: Props) {
    return (
        <section className="overflow-hidden rounded-2xl border border-white/10 bg-[#0d121b]">
            <div className="grid lg:grid-cols-[0.9fr_1.1fr]">
                <div className="h-[280px] lg:h-full">
                    <img
                        src={event.image}
                        alt={event.title}
                        className="h-full w-full object-cover"
                    />
                </div>

                <div className="flex flex-col justify-center gap-5 p-6 md:p-8">
                    <CategoryBadge label="Événement vedette" />

                    <div>
                        <h3 className="text-3xl font-black uppercase leading-tight text-white md:text-4xl">
                            {event.title}
                        </h3>
                        <p className="mt-3 text-base leading-7 text-white/75">
                            {event.summary}
                        </p>
                    </div>

                    <div className="grid gap-3 sm:grid-cols-3">
                        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
                            <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/45">
                                Date
                            </p>
                            <p className="mt-2 text-sm font-black uppercase text-white">
                                {event.dateLabel}
                            </p>
                        </div>

                        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
                            <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/45">
                                Horaire
                            </p>
                            <p className="mt-2 text-sm font-black uppercase text-white">
                                {event.timeLabel}
                            </p>
                        </div>

                        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
                            <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/45">
                                Lieu
                            </p>
                            <p className="mt-2 text-sm font-black uppercase text-white">
                                {event.location}
                            </p>
                        </div>
                    </div>

                    <div>
                        <ActionButton label="Voir le programme" />
                    </div>
                </div>
            </div>
        </section>
    );
}